import data from "../../.sourceflow/expertise.json";
import BaseCollection from "@sourceflow-uk/sourceflow-sdk/base_collection";
import { match } from "@/functions/match";

export const getExpertise = ({ matcher = null, url_slug = null, parent = null, locale = "en" } = {}) => {
  const collection = new BaseCollection(data, locale)
    .orderBy((i) => parseInt(i.order[locale]))
    .map((i) => ({
      ...i,
      href: parent ? `/${data.url_pattern}/${parent.url_slug}/${i.url_slug}` : `/${data.url_pattern}/${i.url_slug}`,
    }));

  if (matcher) {
    return match(matcher, collection);
  }

  if (url_slug) {
    return collection.getJsonItem(url_slug, "url_slug");
  }

  if (parent === false) {
    return collection.filter((i) => i.parent.id === null).getItems();
  }

  if (parent && "id" in parent) {
    return collection.filter((i) => i.parent.id === parent.id).getItems();
  }

  return collection.getItems();
};
